var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.application.productType === 'COMFORT')?_c('ComfortLoanApplicationTimeline',{attrs:{"application":_vm.application}}):_c('RegularLoanApplicationTimeline',{attrs:{"show-future":_vm.showFuture,"application":_vm.application}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }